<template>
	<VkdHeader :barData="barData" @handleLeft="handleLeft"></VkdHeader>
</template>

<script>
import VkdHeader from '@/components/header.vue';

export default {
  name: 'VerifyHeader',
  data() {
    return {
      barData: {
        title: '二次登录认证',
        leftText: '返回',
        leftArrow: true
      }
    }
  },
  computed: {},
  methods: {
    handleLeft() {
      this.$router.go(-1);
    }
  },
  components: {
    VkdHeader
  }
}
</script>

<style lang="scss" scoped>
</style>
